<section
	class="activity-details"
	aria-labelledby="activity-details-title">
	<div class="accessibility-text" aria-live="assertive" aria-atomic="true">
		{{ accessibilityAnnouncer.message$ | async }}
	</div>
	<h2 id="activity-details-title" class="activity-details__title">
		{{ 'activity-preview-editor-activity-settings' | translate }}
	</h2>
	<p class="activity-details__intro">
		{{ 'activity-preview-editor-activity-settings-description' | translate }}
	</p>
	<div class="activity-details__divider" aria-hidden="true"></div>

	@if (activityModel) {
		<ngx-activity-edit
			[activity]="activityModel"
			[useActivityPreviewEditorLayout]="true"
			[showMasterActivityToggle]="showMasterActivityToggle()"
			[isNameReadonly]="isActivityNameReadonly()"
			[isLibraryEnvironment]="isLibraryEnvironment()"
			(masterActivityToggled)="onMasterActivityToggled($event)">
			<participant-rubric-setting
				after-activity-grading>
			</participant-rubric-setting>
		</ngx-activity-edit>
	}
</section>
